<template>
  <div class="roles">
    <div class="page-header">
      <h1>{{ $t('admin.roles') }}</h1>
      <Button class="top-create--btn" type="primary" icon="md-add" to="/roles/0?oper=create">{{
        $t('admin.createRole')
      }}</Button>
    </div>
    <Row :gutter="20">
      <i-col v-for="role in rolesList" :key="role.id" span="8">
        <Card @click.native="showDetail(role, 'view')">
          <img v-if="role.name === 'root'" src="../../assets/images/admin-role.png" width="72" />
          <img v-else src="../../assets/images/role.png" width="72" />
          <div class="role-info">
            <p class="role-title">{{ role.name }}</p>
            <p class="role-desc">{{ role.description | intercept }}</p>
          </div>
          <div v-if="role.name !== 'root'" class="btn-group">
            <Button
              class="edit-btn"
              size="small"
              icon="md-create"
              type="primary"
              shape="circle"
              @click.stop="showDetail(role, 'edit')"
            ></Button>
            <Button
              class="remove-btn"
              size="small"
              icon="md-trash"
              type="error"
              shape="circle"
              @click.stop="handleDelete(role)"
            ></Button>
          </div>
        </Card>
      </i-col>
      <Spin v-if="loading" size="large" fix> </Spin>
    </Row>
    <Page
      v-if="total >= 12"
      show-total
      :current="page"
      :total="total"
      :page-size="limit"
      @on-change="handlePageChange"
      @on-page-size-change="handlePageSizeChange"
    />
  </div>
</template>

<script>
import { loadRoles, deleteRole } from '@/api/admin'

export default {
  name: 'Roles',

  data() {
    return {
      page: 1,
      limit: 12,
      total: 0,
      loading: false,
      rolesList: [],
    }
  },

  filters: {
    intercept(text) {
      if (text && text.length > 60) {
        return `${text.substring(0, 60)}...`
      }
      return text
    },
  },

  created() {
    this.loadData()
  },

  methods: {
    loadData() {
      this.loading = true
      loadRoles({
        $limit: this.limit,
        $skip: (this.page - 1) * this.limit,
      })
        .then((res) => {
          this.rolesList = res.data.data
          this.total = res.data.total
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    handleDelete({ id }) {
      this.$Modal.confirm({
        title: this.$t('common.warning'),
        content: this.$t('common.confirmDelete'),
        onOk: () => {
          deleteRole(id).then(() => {
            this.$Message.success(this.$t('common.deleteSuccess'))
            this.page = 1
            this.loadData()
          })
        },
      })
    },
    showDetail({ id }, oper) {
      this.$router.push({
        path: `/roles/${id}`,
        query: { oper },
      })
    },
    handlePageChange(val) {
      this.page = val
      this.loadData()
    },
    handlePageSizeChange(val) {
      this.limit = val
      this.page = 1
      this.loadData()
    },
  },
}
</script>

<style lang="scss">
.roles {
  .ivu-card {
    cursor: pointer;
    margin-bottom: 20px;
    .ivu-card-body {
      display: flex;
      align-items: center;
    }
    .role-info {
      margin-left: 20px;
      width: 100%;
      .role-title {
        color: var(--color-text-title);
        font-size: 16px;
        margin-bottom: 5px;
      }
    }
    .btn-group {
      width: 55px;
      display: flex;
      justify-content: space-between;
      position: absolute;
      right: 10px;
      top: 13px;
      visibility: hidden;
      .ivu-icon {
        font-size: 15px;
      }
    }
    &:hover .btn-group {
      visibility: visible;
    }
  }
}
</style>
